module.exports = __webpack_public_path__ + "static/media/espen.bc516f5a.JPG";